<template>
  <div style="padding: 20px">
    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="clearfix">查重结果(点击跳转到对应资源)</div>
      <div>
        <template v-if="/^(?!http)/i.test(imageList.url)">
          <h3>文本</h3>
          <div>
            <h4 style="color: red">{{ imageList.url }}</h4>
          </div>
        </template>
        <template v-else>
          <h3>原图</h3>
          <div>
            <img
              class="previewImg"
              style="margin-left: 35px"
              v-lazy="imageList.url"
              alt="origin"
            />
          </div>
        </template>
        <h3>相似图片</h3>
        <div class="resourceContainer">
          <div
            @click="toResource(itm)"
            v-for="itm in imageList.matchResult"
            :key="itm.url"
          >
            <img class="previewImg" v-lazy="itm.url" alt="origin" />
            <div>
              <strong>相似度：{{ (itm.score * 100).toFixed(2) }}%</strong>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { searchLogById } from '../../../api/searchImage'
export default {
  name: 'info',
  data() {
    return {
      imageList: {},
      loading: false
    }
  },
  computed: {
    urlMap() {
      const data = new Map([
        ['wallpaper', '/resource/wallpaper/info/']
      ])
      return data
    },
    linkUrl() {
      return ({ id, type }) => {
        let url = ''
        let mapData = this.urlMap
        url = mapData.get(type) + id
        return url
      }
    }
  },
  methods: {
    toResource(data) {
      if (data.id) {
        this.$router.push(this.linkUrl(data))
      }
    }
  },
  created() {
    this.loading = true
    searchLogById({ id: this.$route.params.id })
      .then((res) => {
        if (res.success) {
          this.imageList = res.data
        }
      })
      .finally((e) => {
        this.loading = false
      })
  }
}
</script>

<style scoped>
.previewImg {
  width: 150px;
  cursor: pointer;
}
.params {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.box-card {
  margin-bottom: 20px;
}
.params > :nth-child(1) {
  flex: 1;
  margin-right: 10px;
}

.params > :nth-child(2) {
  flex: 4;
  margin-right: 10px;
}
.resourceContainer {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  justify-items: center;
}
::v-deep .el-upload {
  width: 100% !important;
}
::v-deep .el-upload-dragger {
  width: 100% !important;
}
</style>
